const BRAND = ["#rawajsmart", "#رواج_الذكية"];
const isBrand = (t) => t.toLowerCase().includes("rawaj") || t.includes("رواج");
const topicOf = (tags) => (tags || []).filter((t) => t && !isBrand(t)).filter((t, i, a) => a.indexOf(t) === i);

// Instagram accepts max 5 hashtags: top 3 topic tags + 2 brand tags.
export const fiveTags = (tags) => [...topicOf(tags).slice(0, 3), ...BRAND];

// Campaign posts: 4 topic tags (campaign/product) + #rawajsmart only.
export const campaignTags = (tags) => [...topicOf(tags).slice(0, 4), BRAND[0]];
